import React, { useState, useEffect } from 'react'
import { Panel, Row, Col, Placeholder, Icon } from 'rsuite'
import { getSummaryOfStatus } from '../../../redux/actions/auditDashboard'
import { numberThousandSeparator } from '../../../utils/formatterUtil'
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min'
import pathname from '../../../constants/pathname'

export default function SummaryOfStatus({ request }) {
  const history = useHistory()

  const [schema, setSchema] = useState()
  const [isLoading, setIsLoading] = useState(false)

  useEffect(() => {
    handleGetSchema()
  }, [request])

  const handleGetSchema = async () => {
    setIsLoading(true)
    try {
      const response = await getSummaryOfStatus(request)

      console.log('resss => ', response)

      setSchema(response)
    } catch (e) {
      console.log('error ', e)
      // setError({})
    }
    setIsLoading(false)
  }

  return (
    <>
      {schema && (
        <Panel
          collapsible
          defaultExpanded
          header={schema.header}
          bordered
          shaded
          style={{ marginTop: 20 }}
        >
          {isLoading && <Placeholder.Graph active />}

          <Row style={{ marginTop: -10 }}>
            <Col xs={24} sm={24} md={24} lg={24} style={{ marginBottom: 20 }}>
              {schema.totalMsg}{' '}
              <span style={{ fontWeight: 'bold', marginLeft: 10, marginRight: 10 }}>
                {numberThousandSeparator(schema.total)}
              </span>{' '}
              โครงการ
            </Col>
            {schema?.datas?.map((item, index) => (
              <Col
                key={index}
                xs={item?.col?.cxs ?? 24}
                sm={item?.col?.csm ?? 24}
                md={item?.col?.cmd ?? 12}
                lg={item?.col?.clg ?? 12}
                style={{ marginBottom: 10 }}
              >
                <div class="parent-container">
                  <div
                    class="card-container"
                    style={{ cursor: 'pointer' }}
                    onClick={() => {
                      history.push(
                        `${pathname.audit.AuditReportSummary}?year=${request}&status=${item.statusCode || ''}`
                      )
                      // history.push({
                      //   pathname: `${pathname.audit.AuditReportSummary}`,
                      //   search: item.StatusCode || '',
                      // })
                    }}
                  >
                    <span class="card-title">{item.label}</span>
                    <div
                      class={`badge-circle ${item.isGreen ? (item.value == schema.total ? 'up' : 'down') : item.value > 0 ? 'down' : 'up'}`}
                    >
                      {numberThousandSeparator(item.value)}
                    </div>
                  </div>
                </div>
              </Col>
            ))}
          </Row>
        </Panel>
      )}
    </>
  )
}
